/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CardFull,
  CardFullOptional,
  CardFullMetaI,
  CardFullTrackedI,
} from "./card-full";
import { CardFullTracked, CardFullMeta } from "./card-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface PurchaseCardDTO
 */
export interface PurchaseCardDTOOptional extends CardFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseCardDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  cardNum?: string;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  issueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  temp?: string;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  active?: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseCardDTO
   */
  personId?: PersonRefOptional;
}

export interface PurchaseCardDTO extends PurchaseCardDTOOptional, CardFull {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseCardDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  cardNum: string;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  issueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  temp?: string;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  active?: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseCardDTO
   */
  personId: PersonRef;
}

export interface PurchaseCardDTOTrackedI extends CardFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseCardDTO
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseCardDTO
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  cardNum?: string;
  cardNumIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  issueDate?: Date;
  issueDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseCardDTO
   */
  temp?: string;
  tempIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseCardDTO
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseCardDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set("PurchaseCardDTO", function (model: PurchaseCardDTO) {
  if (typeof model.purchaseDate == "string")
    model.purchaseDate = new Date(model.purchaseDate);
  if (typeof model.issueDate == "string")
    model.issueDate = new Date(model.issueDate);
  const transformDatespersonId = transformDatesMap.get("PersonRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
});

export type PurchaseCardDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  cardNum: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  issueDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  temp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
}>;

export var PurchaseCardDTOMeta: PurchaseCardDTOMetaI =
  {} as PurchaseCardDTOMetaI;
PurchaseCardDTOMeta = typeMeta("PurchaseCardDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  cardNum: propertyMeta("cardNum", false, true, false, MetaTypesBase.string),
  issueDate: propertyMeta("issueDate", false, false, false, MetaTypesBase.Date),
  temp: propertyMeta("temp", false, false, false, MetaTypesBase.string),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
});

const metaI = PurchaseCardDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CardFullMeta]);
  metaI.isDeleted.inheritedFrom = CardFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = CardFullMeta.isNew;
  metaI.assignId.inheritedFrom = CardFullMeta.assignId;
  metaI.price.inheritedFrom = CardFullMeta.price;
  metaI.purchasableState.inheritedFrom = CardFullMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = CardFullMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = CardFullMeta.voidCloseId;
  metaI.cardNum.inheritedFrom = CardFullMeta.cardNum;
  metaI.issueDate.inheritedFrom = CardFullMeta.issueDate;
  metaI.temp.inheritedFrom = CardFullMeta.temp;
  metaI.active.inheritedFrom = CardFullMeta.active;
  metaI.personId.inheritedFrom = CardFullMeta.personId;
});

export class PurchaseCardDTOTracked
  extends CardFullTracked
  implements PurchaseCardDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  cardNum__I?: string = undefined;
  cardNumIsSet: boolean = false;
  set cardNum(v: undefined | string) {
    if (v !== undefined) {
      this.cardNum__I = v;
      this.cardNumIsSet = true;
    } else {
      this.cardNum__I = v || undefined;
      this.cardNumIsSet = true;
    }
    this.changeTracker = true;
  }
  get cardNum() {
    return this.cardNum__I;
  }
  issueDate__I?: Date = undefined;
  issueDateIsSet: boolean = false;
  set issueDate(v: undefined | Date) {
    if (v !== undefined) {
      this.issueDate__I = v;
      this.issueDateIsSet = true;
    } else {
      this.issueDate__I = v || undefined;
      this.issueDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get issueDate() {
    return this.issueDate__I;
  }
  temp__I?: string = undefined;
  tempIsSet: boolean = false;
  set temp(v: undefined | string) {
    if (v !== undefined) {
      this.temp__I = v;
      this.tempIsSet = true;
    } else {
      this.temp__I = v || undefined;
      this.tempIsSet = false;
    }
    this.changeTracker = true;
  }
  get temp() {
    return this.temp__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(config?: PurchaseCardDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();
  }
  assignFrom(
    config: PurchaseCardDTOOptional,
    options?: AssignOptions,
  ): PurchaseCardDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (config.cardNum && this.cardNumApplyFilter(optionsRequired.filter)) {
      this.cardNum = config.cardNum;
      if (optionsRequired.unassign) this.cardNumIsSet = false;
      else this.cardNumIsSet = true;
    }
    if (config.issueDate && this.issueDateApplyFilter(optionsRequired.filter)) {
      this.issueDate = config.issueDate;
      if (optionsRequired.unassign) this.issueDateIsSet = false;
      else this.issueDateIsSet = true;
    }
    if (config.temp && this.tempApplyFilter(optionsRequired.filter)) {
      this.temp = config.temp;
      if (optionsRequired.unassign) this.tempIsSet = false;
      else this.tempIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PurchaseCardDTOTrackedI {
    const cloned = {} as PurchaseCardDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.cardNumIsSetDeep() &&
      this.cardNumApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardNumIsSet = true;
      cloned.cardNum = this.cardNum;
    } else {
      //cloned.cardNumIsSet = false
    }
    if (
      this.issueDateIsSetDeep() &&
      this.issueDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.issueDateIsSet = true;
      cloned.issueDate = this.issueDate;
    } else {
      //cloned.issueDateIsSet = false
    }
    if (
      this.tempIsSetDeep() &&
      this.tempApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIsSet = true;
      cloned.temp = this.temp;
    } else {
      //cloned.tempIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PurchaseCardDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.cardNumApplyFilter(filter)) this.cardNumIsSet = false;

    if (!this.issueDateApplyFilter(filter)) this.issueDateIsSet = false;

    if (!this.tempApplyFilter(filter)) this.tempIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.isDeleted,
      PurchaseCardDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.isNew,
      PurchaseCardDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.assignId,
      PurchaseCardDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.price,
      PurchaseCardDTOMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.purchasableState,
      PurchaseCardDTOMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.purchaseDate,
      PurchaseCardDTOMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.voidCloseId,
      PurchaseCardDTOMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  cardNumApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.cardNum,
      PurchaseCardDTOMeta,
      this.cardNum,
      this,
    );
  }
  cardNumIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardNumIsSet && this.cardNumApplyFilter(filter)) return true;

    return false;
  }
  issueDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.issueDate,
      PurchaseCardDTOMeta,
      this.issueDate,
      this,
    );
  }
  issueDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.issueDateIsSet && this.issueDateApplyFilter(filter)) return true;

    return false;
  }
  tempApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.temp,
      PurchaseCardDTOMeta,
      this.temp,
      this,
    );
  }
  tempIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIsSet && this.tempApplyFilter(filter)) return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.active,
      PurchaseCardDTOMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseCardDTOMeta.personId,
      PurchaseCardDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.cardNumIsSetDeep(filter)) return true;
    if (this.issueDateIsSetDeep(filter)) return true;
    if (this.tempIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
